import axios from 'axios'
import { getAPIService } from '../../getServerHost'
import { PageSet } from '../types'

export const getRooms = async ({ limit, page }: PageSet) => {
  const response = await axios.get(`${getAPIService}/v2/api/rooms?limit=${limit}&page=${page}`)
  return response.data
}
